import { render, staticRenderFns } from "./DashboardWarnings.vue?vue&type=template&id=e279b62e"
import script from "./DashboardWarnings.vue?vue&type=script&lang=ts"
export * from "./DashboardWarnings.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports